/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// Notification JS
(function() {
	"use strict";   
    var widthMobile = 992;

    function setCookie(name, value, daysToExpire = 1) {
        const expires = new Date();
        expires.setTime(expires.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
    }

    function getCookie(name) {
        return document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`))
            ?.split('=')[1] || null;
    }

    function deleteCookie(name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    // Check for AEM's authoring classes 
    function isEditOrDesignMode() {
      const params = new URLSearchParams(window.location.search);
      const wcmmode = params.get('wcmmode');
      const isEditorPath = top.location.pathname.includes('/editor.html');
      
      if (wcmmode === 'disabled') {
        return null;
      }
      if (isEditorPath) {
        return 'AUTHOR';
      }
      return 'PUBLISH';
    }
	
    // $(document).ready(function () {	
    document.addEventListener('DOMContentLoaded', function () {
	  const components = document.querySelectorAll('.cmp-flindersonline-notification');
	  if (components.length > 0) {
		components.forEach(component => {
		  component.setAttribute('data-js-loaded', 'true');

            const slider = component.querySelector('.notification-slider');
            const sliderContainer = component.querySelector('.slider-container');
            const dotsContainer = component.querySelector('.slider-dots');
            const slides = component.querySelectorAll('.slide');
            const globalHeader = document.querySelector('.global_header'); 
            const timerCount = parseInt(component.dataset.autoRotationTimer, 10) || 5;
            const mobileLimit = 30;
            const desktopLimit = 145;            
            const notificationBar = component.closest('.notification-bar'); 
            const header_site = document.querySelector('.header_site');
            const flindersOnlineHeader = document.querySelector('.cmp-flindersonline-header');
            const notificationCookie = getCookie("notificationClosed");
            const subPageGlobalHeader = document.querySelector(".subpage_global_header");
            const subLogoLine = document.querySelector(".sublogoline");
            
            var closeNotification = false;
            var isStaffPortalHeader = false;
            if($(".author").length) {
                isAuthor = true;
            }
            if($(".sub_site_header").length) {
                isStaffPortalHeader = true;
            }

            let notificationScrollRegistered = false;
            window.doNotificationFixups = function() {
                var isMobile = $(window).width() <= widthMobile;

                if(flindersOnlineHeader){
                    flindersOnlineHeader.insertBefore(component, flindersOnlineHeader.firstElementChild);
                } else if (header_site) {
                    const checkTopOffset = header_site ? header_site.offsetHeight : 0;
                    let LastY = window.scrollY >0  ? 0 : checkTopOffset + 1;
                    function doScrollFixup(){
                        var isMobile = $(window).width() <= widthMobile;
                        if(!isMobile)
                        {
                            const ScrollY = window.scrollY;
                            if(ScrollY > checkTopOffset && LastY <=checkTopOffset){
                                globalHeader.insertBefore(component, globalHeader.firstElementChild);
                            } else if(ScrollY <= checkTopOffset && LastY > checkTopOffset) {
                                header_site.parentElement.insertBefore(component, header_site);

                                if(!isStaffPortalHeader){
                                    var global_header_top = $('.header_site').offset().top;
                                    global_header_top = global_header_top + 25;
                                    var top_text =  "calc( "+global_header_top+"px * 1 / var(--recite-me-zoom) )";
                                    $('.global_header').css("top", top_text );
                                }
                            } 
                            LastY = ScrollY;
                        }
                    }
                    
                    if(isMobile){
                        globalHeader.insertBefore(component, globalHeader.firstElementChild);
                    } else if(globalHeader && ! subPageGlobalHeader){
                        if(!notificationScrollRegistered){
                            window.addEventListener("scroll", doScrollFixup);
                            notificationScrollRegistered = true;
                        }
                        doScrollFixup();
                    } else {
                        header_site.parentElement.insertBefore(component, header_site);
                    }
                } else {
                    console.warn("We appear to be on a page that doesn't have either the flinders online header or the sites_header?");
                }
                fixupHeaderPadding();
                if(window.fixupMobileMenu){
                    requestAnimationFrame(fixupMobileMenu);
                }
            }

            doNotificationFixups();

            RegisterPostGDPRHook(function(){ 
                if(globalHeader){
                    globalHeader.style.top = "";
                }
                doNotificationFixups()
            });

            addEventListener("resize", doNotificationFixups);

            


            if(!notificationCookie){
                component.classList.remove('hidden');
                component.classList.add('active');
            }

            const closeBtn = component.querySelector('.close-notification-btn');
            
            closeBtn.addEventListener('click', function() {
                setCookie("notificationClosed", "true", 1);
                closeNotification = true;
                hideNotification();
            }, { once: true });


            function hideNotification(){
                component.classList.add('hidden');
                notificationBar.classList.add('hidden');
                doNotificationFixups();
            }


            let currentIndex = 0;
            let slideInterval;
            const slideCount = slides.length;
            
            // Initialize dots based on slide count
            const initDots = () => {
                dotsContainer.innerHTML = '';
                slides.forEach((_, index) => {
                    const dot = document.createElement('div');
                    dot.className = `dot ${index === 0 ? 'active' : ''}`;
                    dot.dataset.index = index;
                    dotsContainer.appendChild(dot);
                    
                    dot.addEventListener('click', () => { 
                        if(currentIndex !== index) {
                            goToSlide(index);
                        }
                    });
                });
            };

            function updateSlideText(){
                slides.forEach((_, index) => {
                    const desktop = _.querySelector('.desktop-only');
                    const mobile = _.querySelector('.mobile-only');
                    let text_desktop = desktop.innerHTML;
                    let text_mobile = mobile.innerHTML;
                    
                    if (desktop.textContent.length > desktopLimit) {
                        desktop.textContent = desktop.textContent.substring(0, desktopLimit);
                    }
                    
                    if (mobile.textContent.length > mobileLimit) {
                        mobile.textContent = mobile.textContent.substring(0, mobileLimit);
                    }
                })
            }
            
            // Go to specific slide
            const goToSlide = (index) => {
                if(!slides || index >= slides.length){
                    console.warn("Asked to go to non-existant slide, ignoring", slides, index);
                    return;
                }
                slides[currentIndex].classList.remove('active');
                document.querySelector(`.dot[data-index="${currentIndex}"]`).classList.remove('active');
                
                currentIndex = index;
                
                slides[currentIndex].classList.add('active');
                document.querySelector(`.dot[data-index="${currentIndex}"]`).classList.add('active');
                
                resetInterval();
            };
            
            // Start auto rotation
            const startAutoSlide = () => {
                if (autoSlideEnabled) {
                    slideInterval = setInterval(() => {
                        const nextIndex = (currentIndex + 1) % slideCount;
                        goToSlide(nextIndex);
                    }, timerCount * 1000);
                }
            };

            // Track auto slide state
            let autoSlideEnabled = true;
            
            // Reset interval timer
            const resetInterval = () => {
                clearInterval(slideInterval);
                startAutoSlide();
            };
            
            // Initialize slider
            const initSlider = () => {
                initDots();
                updateSlideText();
                resetInterval();
            };
            
            // Pause on hover
            slider.addEventListener('mouseenter', () => {
                autoSlideEnabled = false;
                clearInterval(slideInterval)
            });

            slider.addEventListener('mouseleave', () => {                
                autoSlideEnabled = true;
                startAutoSlide();
            });
            
            initSlider();
		});
	  }
	});
})();